if ($("body:not(.ordering-process)").length) {
  var SCRAPE_REVIEWS_CLOSED_KEY = "scrapeCustomReviewsClosed";
  var SCRAPE_REVIEWS_REMOVED_KEY = "scrapeCustomReviewsRemoved";

  $("body").append(`
        <div class="scrapeCustomRewiews closed">
        <span class="close"></span>
            <div class="scrapeTop">
                <span class="scrapeStar"><span class="stars"></span></span>
            </div>
            <div class="scrapeCenter">
                <span class="scrapeCount"></span>
                <span class="scrapeNumbers"><a href="${recenzeUrl}"></a></span>
            </div>
            <div class="scrapeBottom">
                <p>${translation("zoverenychplatforem")}</p>
            </div>
        </div>
    `);

    try {
      if (window.sessionStorage.getItem(SCRAPE_REVIEWS_REMOVED_KEY) === "1") {
        $(".scrapeCustomRewiews").addClass("removed");
      }
    } catch (e) {}

  try {
    if (window.localStorage.getItem(SCRAPE_REVIEWS_CLOSED_KEY) === "0") {
      $(".scrapeCustomRewiews").removeClass("closed");
    } else if (window.localStorage.getItem(SCRAPE_REVIEWS_CLOSED_KEY) === "1") {
      $(".scrapeCustomRewiews").addClass("closed");
    }
  } catch (e) {}

  $("html").on("click", ".scrapeCustomRewiews .close", function () {
    $(".scrapeCustomRewiews").addClass("removed");
    try {
      window.sessionStorage.setItem(SCRAPE_REVIEWS_REMOVED_KEY, "1");
    } catch (e) {}
  });

  $("html").on("click", ".scrapeCustomRewiews .scrapeCount", function () {
    $(".scrapeCustomRewiews").removeClass("closed");
    try {
      window.localStorage.setItem(SCRAPE_REVIEWS_CLOSED_KEY, "0");
    } catch (e) {}
  });

  var API_TOKEN = "sc_cbfc54b614ca5aba548e09f403a725073c39bc8cc550fc8869a416f2073392df";
  var API_BASE = "https://aplikace.shopcode.cz/api/v1";
  $.ajax({
    url: API_BASE + "/scraped-reviews/stats",
    method: "GET",
    headers: { Authorization: "Bearer " + API_TOKEN },
    success: function (response) {
      var d = response.data;
      $(".scrapeCustomRewiews .scrapeNumbers a").html(d.total + " " + getRecenzeText(d.total));
      $(".scrapeCustomRewiews .scrapeStar .stars").html(renderStars(d.average_rating));
      $(".scrapeCustomRewiews .scrapeCount").html(d.average_rating);
    },
    error: function (xhr) {
      console.error("Chyba:", xhr.status, xhr.responseText);
    },
  });

  if (window.location.pathname === recenzeUrl) {
    $("header#header").after(`
            <div class="pageTop">
                <div class="container">
                </div>
            </div>
        `);
    $(".pageTop").prepend($(".breadcrumbs-wrapper"));
    $(".pageTop .container:not(.breadcrumbs-wrapper)").append($(".customWrapper").clone());
    $(".pageTop .container:not(.breadcrumbs-wrapper) .customWrapper .left").prepend($('header[itemprop="headline"]'));
    $('div[itemprop="about"]').append(`
            <div class="customRewtop"></div>
            <div class="rw-filters">

                <div class="rw-filter-group">
                    <span class="rw-filter-label">${translation("zdrojrecenze")}</span>
                    <div class="rw-dd" id="filterSource">
                        <div class="rw-dd-trigger">
                            <span class="rw-dd-label">${translation("vsechnyzdroje")}</span>
                            <span class="rw-dd-arrow"></span>
                        </div>
                        <div class="rw-dd-menu">
                            <ul></ul>
                        </div>
                    </div>
                </div>

                <div class="rw-filter-group">
                    <span class="rw-filter-label">${translation("pocethvezd")}</span>
                    <div class="rw-dd" id="filterRating">
                        <div class="rw-dd-trigger">
                            <span class="rw-dd-label">${translation("vsechnahodnoceni")}</span>
                            <span class="rw-dd-arrow"></span>
                        </div>
                        <div class="rw-dd-menu">
                            <ul></ul>
                        </div>
                    </div>
                </div>

            </div>
            <div id="reviewsList"></div>
            <div class="text-center customButtonRew"><button class="btn btn-primary" id="btnLoadMore">${translation("nacistDalsi")}</button></div>
        `);
    var API_TOKEN = "sc_cbfc54b614ca5aba548e09f403a725073c39bc8cc550fc8869a416f2073392df";
    var API_BASE = "https://aplikace.shopcode.cz/api/v1";
    var PER_PAGE = 28;
    var state = { lang: "", source_id: "", rating: "", page: 1 };
    var loading = false;
    var sourcesLoaded = false;
    var statsRendered = false;
    load(false);
  }
}

var AUTHOR_MAP = {
  "Zákazník Heureka": translation("zakaznik"),
  "Community Member": translation("zakaznik"),
};

function getRecenzeText(count) {
  if (count === 1) return translation("recenze");
  if (count >= 2 && count <= 4) return translation("recenze");
  return translation("recenzi");
}

function renderStars(rating) {
  rating = parseFloat(rating);
  const rounded = Math.round(rating * 2) / 2;
  let html = "";
  for (let i = 1; i <= 5; i++) {
    let starClass = "star-off";
    if (rounded >= i) {
      starClass = "star-on";
    } else if (rounded >= i - 0.5) {
      starClass = "star-half";
    }
    html += `<span class="star ${starClass}"></span>`;
  }
  return html;
}

// API neumí řadit podle jazyka → stáhnou se všechny recenze (max 200 na stránku),
// recenze v jazyce webu (DISPLAY_LANG) jdou první a stránkuje se lokálně.
var FETCH_PER_PAGE = 200;
var allReviews = [];

function baseLang(lang) {
  return (lang || "").toString().toUpperCase().split("-")[0];
}

function sortLocalFirst(items) {
  var local = baseLang(DISPLAY_LANG);
  var first = [];
  var rest = [];
  $.each(items, function (i, r) {
    (baseLang(r.source_lang) === local ? first : rest).push(r);
  });
  return first.concat(rest);
}

function fetchReviewsPage(page) {
  var params = { per_page: FETCH_PER_PAGE, page: page };
  if (state.source_id) params.source_id = state.source_id;
  if (state.rating) params.rating = state.rating;

  return $.ajax({
    url: API_BASE + "/scraped-reviews",
    method: "GET",
    headers: { Authorization: "Bearer " + API_TOKEN },
    data: params,
  });
}

function renderPage(append) {
  var start = (state.page - 1) * PER_PAGE;
  renderCards(allReviews.slice(start, start + PER_PAGE), append);

  if (state.page * PER_PAGE < allReviews.length) {
    $("#btnLoadMore").prop("disabled", false).text(translation("nacistDalsi")).show();
  } else {
    $("#btnLoadMore").hide();
  }
}

function load(append) {
  // Další stránka už je stažená
  if (append) {
    renderPage(true);
    return;
  }

  if (loading) return;
  loading = true;

  fetchReviewsPage(1)
    .then(function (r) {
      // Stats a filtry jen při úplně prvním načtení
      if (!statsRendered) {
        $(".customRewtop").append(renderRateWrap(r.stats));
        renderFilters(r.stats);
        renderRateWrapCustom(r.stats);
        renderRateList(r.stats);
        statsRendered = true;
      }

      var requests = [];
      for (var p = 2; p <= r.pagination.pages; p++) {
        requests.push(fetchReviewsPage(p));
      }
      if (!requests.length) return [r.data];

      return $.when.apply($, requests).then(function () {
        // $.when s jedním požadavkem vrací rovnou [data, status, xhr], s více pole těchto trojic
        var rest = requests.length === 1 ? [arguments] : Array.prototype.slice.call(arguments);
        return [r.data].concat(
          rest.map(function (res) {
            return res[0].data;
          })
        );
      });
    })
    .then(function (pages) {
      allReviews = sortLocalFirst([].concat.apply([], pages));
      renderPage(false);
    })
    .fail(function (xhr) {
      $("#reviewsList").html("<p>" + translation("chyba") + " " + xhr.status + "</p>");
      $("#btnLoadMore").hide();
    })
    .always(function () {
      loading = false;
    });
}

$("#btnLoadMore").on("click", function () {
  state.page++;
  load(true);
});

function renderRateWrap(stats) {
  var avg = stats.average_rating || 0;
  var total = stats.total || 0;
  var dist = stats.distribution || {};

  var starsHtml = renderStars(avg);

  var left = "" + '<div class="customRateLeft">' + '<div class="inner">' + '<span class="customRateNumber">' + avg + "</span>" + '<span class="customrateStars">' + '<span class="stars">' + starsHtml + "</span>" + '<span class="starsLabel">' + total + " " + getRecenzeText(total) + "</span>" + "</span>" + "</div>" + "</div>";

  var right = '<div class="customRateRight">';
  for (var s = 5; s >= 1; s--) {
    var count = dist[s] || 0;
    var pct = total > 0 ? Math.round((count / total) * 100) : 0;
    right += "" + '<div class="rateList" data-score="' + s + '">' + '<div class="rateStar stars">' + '<span class="rateValue">' + s + "</span>" + '<span class="star star-on"></span>' + "</div>" + '<div class="rate-block">' + '<span class="rate-bar" style="width:' + pct + '%;">' + "</span>" + "</span>" + "</div>" + '<div class="customCount">' + count + "x</div>" + "</div>";
  }
  right += "</div>";

  return left + right;
}

function renderRateWrapCustom(stats) {
  var avg = stats.average_rating || 0;
  var starsHtml = renderStars(avg);
  $(".pageTop .container:not(.breadcrumbs-wrapper) .customWrapper .left .head .big .number").append(avg);
  $(".pageTop .container:not(.breadcrumbs-wrapper) .customWrapper .left .head .stars").html(starsHtml);
}

function renderRateList(stats) {
  var perSource = stats && Array.isArray(stats.per_source) ? stats.per_source : [];
  var $items = $(".pageTop .container:not(.breadcrumbs-wrapper) .customWrapper .right .wrapper.first .item");

  function toNumber(value) {
    var n = parseFloat(value);
    return Number.isFinite(n) ? n : NaN;
  }

  function formatRating(value) {
    return value
      .toFixed(2)
      .replace(/\.00$/, "")
      .replace(/(\.\d)0$/, "$1");
  }

  function getAverageByPlatform(platform) {
    var matches = perSource
      .filter(function (source) {
        return source.platform === platform;
      })
      .map(function (source) {
        return toNumber(source.average_rating);
      })
      .filter(function (value) {
        return !Number.isNaN(value);
      });

    if (!matches.length) return null;
    var sum = matches.reduce(function (acc, value) {
      return acc + value;
    }, 0);
    return sum / matches.length;
  }

  $items.each(function () {
    var $item = $(this);
    var sourceKey = ($item.data("source") || "").toString().trim().toLowerCase();
    var rating = null;

    if (!sourceKey) return;

    if (sourceKey === "trusted") {
      rating = getAverageByPlatform("trustedshops");
    } else {
      rating = getAverageByPlatform(sourceKey);
    }

    $item.find(".number").text(formatRating(rating));
    $item.find(".stars").html(renderStars(rating));
  });
}

var LANG_LOCALE = {
  CS: "cs-CZ",
  SK: "sk-SK",
  DE: "de-DE",
  PL: "pl-PL",
  NL: "nl-NL",
  "EN-GB": "en-GB",
  EN: "en-US",
  HU: "hu-HU",
  FR: "fr-FR",
  IT: "it-IT",
  RU: "ru-RU",
  UK: "uk-UA",
};

function formatDate(dateStr) {
  if (!dateStr) return "";
  var locale = LANG_LOCALE[DISPLAY_LANG] || "cs-CZ";
  console.log(locale);
  return new Date(dateStr).toLocaleDateString(locale, {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

function renderReviewCard(r) {
  var translatedContent = r.translations && r.translations[DISPLAY_LANG] ? r.translations[DISPLAY_LANG] : r.display_content || r.content || "";
  var originalContent = r.content || "";
  var srcLang = r.source_lang ? r.source_lang.toUpperCase() : "";
  var icon = PLATFORM_ICONS[r.platform] || "";
  var authorDisplay = AUTHOR_MAP[r.author] || r.author || translation("zakaznik");

  // Výchozí: zobrazuje se překlad → vlajka je source_lang (jazyk originálu)
  var flagHtml = "";
  if (srcLang && LANG_FLAGS[srcLang]) {
    flagHtml = '<span class="rating-source-lang"' + ' data-translated="' + $("<b>").text(translatedContent).html() + '"' + ' data-original="' + $("<b>").text(originalContent).html() + '"' + ' data-src-lang="' + srcLang + '"' + ' data-state="translated"' + ' title="' + translation("zobrazitOriginal") + '">' + '<img src="' + LANG_FLAGS[srcLang] + '" alt="' + srcLang + '" class="rating-lang-flag">' + "</span>";
  }

  var iconLangHtml = "";
  if (srcLang && LANG_FLAGS[srcLang]) {
    iconLangHtml = "<i>" + translation("zobrazitOriginal") + "</i>";
  }

  return "" + '<div class="rating-item">' + '<div class="ratingsTop">' + '<span class="stars">' + renderStars(r.rating) + "</span>" + flagHtml + '<span class="rating-date">' + formatDate(r.reviewed_at) + "</span>" + "</div>" + (translatedContent ? '<div class="rating-text">' + $("<b>").text(translatedContent).html() + "</div>" : '<div class="rating-text rating-no-text">' + translation("notext") + "</div>") + '<div class="rating-item-header">' + '<span class="rating-author">' + $("<b>").text(authorDisplay).html() + (translatedContent ? iconLangHtml : "") + "</span>" + '<div class="rating-item-meta">' + (icon ? '<img class="rating-platform-icon" src="' + icon + '" alt="' + r.platform + '">' : '<span class="rating-platform-name">' + (r.platform || "") + "</span>") + "</div>" + "</div>" + "</div>";
}

function renderCards(items, append) {
  if (!append) $("#reviewsList").empty();
  if (!items.length && !append) {
    $("#reviewsList").html("<p>" + translation("zadneRecenzeNeOdpovidajiFiltru") + "</p>");
    return;
  }
  $.each(items, function (i, r) {
    $("#reviewsList").append(renderReviewCard(r));
  });
}

function renderFilters(stats) {
  // Platformy ze stats.per_source
  var platformHtml = '<li class="active" data-filter="source" data-val="">' + translation("vsechnyzdroje") + "</li>";
  $.each(stats.per_source || [], function (i, src) {
    var label = SOURCE_LABELS[src.id] || src.name;
    platformHtml += '<li data-filter="source" data-val="' + src.id + '">' + (PLATFORM_ICONS[src.platform] ? '<img src="' + PLATFORM_ICONS[src.platform] + '" alt="' + label + '"> ' : "") + label + "</li>";
  });
  $("#filterSource ul").html(platformHtml);

  // Hvězdičky 5→1
  var starsHtml = '<li class="active" data-filter="rating" data-val="">' + translation("vsechnahodnoceni") + "</li>";
  for (var s = 5; s >= 1; s--) {
    starsHtml += '<li data-filter="rating" data-val="' + s + '" data-count="' + (stats.distribution[s] || 0) + '">' + '<span class="stars">' + renderStars(s) + "</span>" + ' <span class="filter-count">' + (stats.distribution[s] || 0) + "x</span>" + "</li>";
  }
  $("#filterRating ul").html(starsHtml);
}

$("html").on("click", ".rw-dd-menu li", function (e) {
  var filter = $(this).data("filter");
  var val = $(this).data("val");
  var $dd = $(this).closest(".rw-dd");

  $(this).siblings().removeClass("active").end().addClass("active");
  $(".rw-dd").removeClass("open");

  // zabránit tomu, aby klik zachytil i cizí (vendor) listener na documentu
  e.stopPropagation();

  // Label: hvězdičky pro rating, text pro zbytek
  if (filter === "rating" && val) {
    $dd.find(".rw-dd-label").html('<span class="stars">' + renderStars(val) + "</span>");
  } else {
    $dd.find(".rw-dd-label").text($(this).text().trim());
  }

  if (filter === "source") state.source_id = val;
  if (filter === "rating") state.rating = val;
  state.page = 1;
  $("#reviewsList").empty();
  load(false);
});

$("html").on("click", ".rw-dd-trigger", function (e) {
  var $dd = $(this).closest(".rw-dd");
  var isOpen = $dd.hasClass("open");
  var val = $dd.find("li.active").data("val");

  // Pro filterRating zobraz hvězdičky v triggeru místo textu
  if ($dd.attr("id") === "filterRating" && val) {
    $dd.find(".rw-dd-label").html('<span class="stars">' + renderStars(val) + "</span>");
  }

  $(".rw-dd").removeClass("open");
  if (!isOpen) $dd.addClass("open");

  // zabránit tomu, aby klik zachytil i cizí (vendor) listener na documentu
  // a hned zase dropdown zavřel
  e.stopPropagation();
});

$("html").on("click", function (e) {
  if (!$(e.target).closest(".rw-dd").length) $(".rw-dd").removeClass("open");
});

$("html").on("click", ".rating-source-lang", function () {
  var $flag = $(this);
  var $text = $flag.closest(".rating-item").find(".rating-text");
  var state = $flag.data("state");
  var translated = $flag.data("translated");
  var original = $flag.data("original");
  var srcLang = $flag.data("src-lang");

  if (state === "translated") {
    // Zobraz originál → vlajka se změní na DISPLAY_LANG
    $text.text(original);
    $flag
      .find("img")
      .attr("src", LANG_FLAGS[DISPLAY_LANG] || LANG_FLAGS[srcLang])
      .attr("alt", DISPLAY_LANG);
    $flag.data("state", "original").attr("title", translation("zobrazitPreklad"));
  } else {
    // Zpět na překlad → vlajka se vrátí na source_lang
    $text.text(translated);
    $flag.find("img").attr("src", LANG_FLAGS[srcLang]).attr("alt", srcLang);
    $flag.data("state", "translated").attr("title", translation("zobrazitOriginal"));
  }
});

$("html").on("click", ".rating-author i", function () {
  const $btn = $(this).closest(".rating-item").find(".rating-source-lang");
  $btn.trigger("click");
  const $el = $(this);

  if ($el.text().trim() === translation("zobrazitPreklad")) {
    $el.text(translation("zobrazitOriginal"));
  } else {
    $el.text(translation("zobrazitPreklad"));
  }
});
